export enum OversizeSieveApertureSizeType {
  Sieve0_400mm = '0_400',
  Sieve0_425mm = '0_425',
}

export enum PasteWaterContentEquilibriumType {
  NotRequired = 'NotRequired',
  AirDrying = 'AirDrying',
  Soaking = 'Soaking',
}

export enum PreparationMethodType {
  BS_EN_ISO = 'BS EN ISO 17892-12',
  BS_1377_2 = 'BS 1377-2 Clause 5, 6',
  BS_1377_2_Clause_6 = 'BS 1377-2 Clause 6',
}

export enum OversizeMaterialRemovedByType {
  Hand = 'Hand',
  WetSieving = 'Wet Sieving',
}

export enum ConeType {
  Type_80_30 = 'Type_80_30',
  Type_60_60 = 'Type_60_60',
}

export enum MaterialSuitability {
  MaterialSuitable = 'MaterialSuitable',
  NotTested_LLCouldNotBeObtained = 'NotTested_LLCouldNotBeObtained',
  ResultCannotBeDetermined = 'ResultCannotBeDetermined',
}

export enum CorrelationFactorSource {
  CalculatedFromBS1377Equations = 'CalculatedFromBS1377Equations',
  CalculatedFromEnteredEquation = 'CalculatedFromEnteredEquation',
  EnteredValue = 'EnteredValue',
}

export enum OptionalCharts {
  None = 'None',
  PlasticityChart = 'Plasticity Chart',
  LiquidLimitChart = 'Liquid Limit Chart',
}
